export enum inactiveUsersTypes {
  GET_INACTIVE_USERS = '@@inactiveUsers/GET_INACTIVE_USERS',
  GET_INACTIVE_USERS_SUCCESS = '@@inactiveUsers/GET_INACTIVE_USERS_SUCCESS',
  GET_INACTIVE_USERS_FAIL = '@@inactiveUsers/GET_INACTIVE_USERS_FAIL',

  ACTIVE_USER = '@@inactiveUsers/ACTIVE_USER',
  ACTIVE_USER_SUCCESS = '@@inactiveUsers/ACTIVE_USER_SUCCESS',
  ACTIVE_USER_FAIL = '@@inactiveUsers/ACTIVE_USER_FAIL',
}
